export default "__VITE_ASSET__fda57d30__"